import { useSelector } from 'react-redux'

import { CollectionUUID } from '@library/menu-service'

import type { Collection } from 'reducers/menu-collections/menuCollections'
import { getCollection } from 'selectors/menu-collections/getCollection'

export const useCollection = (id: CollectionUUID | null): Collection | null =>
  useSelector(getCollection(id))
